import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import axios from "axios";
import { isAndroidApp } from "@/lib/platform";
import { captureAttribution } from "@/lib/attribution";

// Tell the backend which shell this is, so the admin user list can show
// who is on the Play Store app. They are the people who cannot upgrade
// in-app and have to be reached by email instead.
//
// Set once, here, because the android-app:// referrer that identifies a
// TWA is only on the very first navigation.
if (isAndroidApp()) {
  axios.defaults.headers.common["X-Mimique-Platform"] = "android";
}

// Before anything renders, so the referrer and any utm tags on the very
// first page view are recorded even if they leave straight after.
captureAttribution();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Production only. In development the dev server rebuilds assets constantly and
// a service worker sitting in front of them just serves stale ones.
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((err) => console.error("Service worker registration failed:", err));
  });
}
